import AdvisorDashboardShell from '@/components/AdvisorDashboardShell';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchClientsForAdvisorByAdvisorIdRequest,
  fetchSubordinateAdvisorsByAdvisorIdRequest,
} from '@client';
import { selectSessionAdvisor } from '@/model/selectors';

import type { DashboardConfig } from '@/components/dashboard-config';

const GENWORTH_DASHBOARD_CONFIG: DashboardConfig = {
  sidebar: {
    showFillIntakeForm: false,
    showInviteClient: false,
    showIntakeFormLink: false,
    quickStartDirect: true,
    showIntegrations: false,
    showEngagementCampaigns: false,
    showSubscription: false,
    showTeam: false,
    showMetrics: false,
  },
  clients: {
    headerPrimaryAction: 'quickStart',
    hiddenColumnIds: ['organization', 'source'],
    showExploreQuotes: false,
  },
};

export function GenworthDashboard(_props: AdvisorIdProps) {
  const advisor = useSelector(selectSessionAdvisor);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      fetchClientsForAdvisorByAdvisorIdRequest({
        advisorId: advisor.advisorId,
        isInvalidation: false,
      }),
    );
    dispatch(
      fetchSubordinateAdvisorsByAdvisorIdRequest({
        advisorId: advisor.advisorId,
      }),
    );
  }, [dispatch, advisor.advisorId]);

  return <AdvisorDashboardShell config={GENWORTH_DASHBOARD_CONFIG} />;
}
